import ctl from "@netlify/classnames-template-literals";

export const sidebar = ctl(`
  hidden
  overflow-y-auto
  md:fixed
  md:flex
  md:h-full
  md:w-80
  md:shrink-0
  md:flex-col
  md:items-start
  md:border-r
  md:bg-white
  md:p-3
`);

export const sidebarDark = ctl(`
  ${sidebar}
  md:!w-64
  md:!bg-purple-950
  md:!border-r-purple-900
  md:!py-10
  md:!px-4
  md:h-full
`);
